import { BannedUser } from '@weblite/ts-action/subscription'
import { PrivacyType } from '@weblite/ts-action/user-policy'
import { useSearchedUserByIds } from '$logic/users'
import {
  OpenedUserListItem,
  useOpenedUserListAsyncIntegration,
} from '$logic/opened-user-list'
import { getBlockedUsers, getUserPolicy } from './service'

export function useBlockedUsers() {
  return useOpenedUserListAsyncIntegration(
    () =>
      getBlockedUsers().then(res =>
        res ? res.userIds.map(id => ({ id } as BannedUser)) : [],
      ),
    [],
    'blockedUsers',
  )
}

export function useSearchBlockedUsers({
  query,
  fetchedItems,
}: {
  query: string
  fetchedItems: { id: string }[]
}) {
  const { loading, searchedItems } = useSearchedUserByIds({
    query,
    userIds: fetchedItems.map(({ id }) => id),
  })
  return { loading, searchedItems: searchedItems.map(id => ({ id })) }
}

export function usePrivacyExceptionUsers(
  privacyType: PrivacyType,
  exceptionType: 'never' | 'always',
) {
  return useOpenedUserListAsyncIntegration(async () => {
    const policy = await getUserPolicy(privacyType)
    return policy[exceptionType === 'always' ? 'include' : 'exclude'].map(
      id =>
        ({
          id,
        } as OpenedUserListItem),
    )
  }, [privacyType])
}

export function useSearchedPrivacyExceptionUsers({
  query,
  fetchedItems,
}: {
  query: string
  fetchedItems: { id: string }[]
}) {
  const { loading, searchedItems } = useSearchedUserByIds({
    query,
    userIds: fetchedItems.map(item => item.id),
  })
  return {
    loading,
    searchedItems: searchedItems.map(id => ({ id })),
  }
}
